module.exports = __webpack_public_path__ + "static/img/code.61636092.png";